import { Badge } from "@/components/ui/badge";
import { TransactionStatus } from "@/openapi/generated";
export { TRANSACTION_STATUS_COLORS } from "@donista/shared/constants/transactions";

type BadgeVariant = "default" | "secondary" | "destructive" | "outline";

interface StatusBadgeProps {
  variant: BadgeVariant;
  className?: string;
}

export function getTransactionStatusBadgeProps(status: TransactionStatus | string): StatusBadgeProps {
  switch (status) {
    case TransactionStatus.VALIDATED:
    case TransactionStatus.PAID:
      return { variant: "outline", className: "border-transparent bg-green-600 text-white" };
    case TransactionStatus.PENDING:
      return { variant: "outline", className: "border-transparent bg-amber-500 text-white" };
    case TransactionStatus.RECEIVED:
      return { variant: "outline", className: "border-transparent bg-emerald-500 text-white" };
    case TransactionStatus.DENIED:
    case TransactionStatus.DELETED:
      return { variant: "destructive" };
    default:
      return { variant: "secondary" };
  }
}

export function TransactionStatusBadge({ status, label }: { status: TransactionStatus; label?: string }) {
  const { variant, className } = getTransactionStatusBadgeProps(status);
  return <Badge variant={variant} className={className}>{label ?? status}</Badge>;
}
